import React, { useState, useEffect } from 'react';
import { Form, Row, Col, InputGroup, Button, Modal, Table } from 'react-bootstrap';
import { Search } from 'react-bootstrap-icons';
import Select from 'react-select';
import axios from 'axios';
import APIserver from '../../../../api/axiosConfig';

function ClienteFactura({ setClienteID, setVenceDate, setTipoFactura, setformaPago, setAsesor, setCreacionDate, settransportadora, pedidoId, setdondePago, setnumGuia }) {
    const [idCliente, setIdCliente] = useState('');
    const [clienteID, setClienteIDs] = useState('');
    const [nomCliente, setNomCliente] = useState('');
    const [creacionDate, setCreacionDateState] = useState('');
    const [venceDate, setVenceDateState] = useState('');
    const [tipoFactura, setTipoFacturaState] = useState('');
    const [clientes, setClientes] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [searchResults, setSearchResults] = useState([]);
    const [selectedCliente, setSelectedCliente] = useState(null);
    const [asesores, setAsesores] = useState([]);
    const [selectedAsesor, setSelectedAsesor] = useState(null);
    const [preferredFormaPago, setPreferredFormaPago] = useState(() => {
        try {
            return localStorage.getItem('forma_pago_preferida_fac') || 'efectivo';
        } catch (e) {
            return 'efectivo';
        }
    });
    const [preferredTransportadora, setPreferredTransportadora] = useState(() => {
        try {
            return localStorage.getItem('transportadora_preferida_fac') || '';
        } catch (e) {
            return '';
        }
    });
    const [formaPago, setformaPagoState] = useState(() => {
        try {
            return localStorage.getItem('forma_pago_preferida_fac') || 'efectivo';
        } catch (e) {
            return 'efectivo';
        }
    });
    const [transport, settransportadoraState] = useState(() => {
        try {
            return localStorage.getItem('transportadora_preferida_fac') || '';
        } catch (e) {
            return '';
        }
    });
    const [dondePago, setDondePagoState] = useState('');
    const [numGuia, setNumGuiaState] = useState('');

    useEffect(() => {
        // Establecer la fecha actual al cargar el componente
        const today = new Date();
        const yyyy = today.getFullYear();
        const mm = String(today.getMonth() + 1).padStart(2, '0');
        const dd = String(today.getDate()).padStart(2, '0');
        const todayDate = `${yyyy}-${mm}-${dd}`;

        setCreacionDateState(todayDate); // Fecha de elaboración
        setVenceDateState(todayDate);    // Fecha de vencimiento

        // Cargar asesores al iniciar
    }, []);

    useEffect(() => {
        setTipoFactura(tipoFactura); // Actualiza tipoFactura en el componente principal
    }, [tipoFactura, setTipoFactura]);

    useEffect(() => {
        if (pedidoId) {
            fetchPedidoData(pedidoId);
        }
    }, [pedidoId]);
    useEffect(() => {
        setformaPago(formaPago);
    }, [formaPago, setformaPago]);

    useEffect(() => {
        settransportadora(transport);
    }, [transport, settransportadora]);
    const fetchPedidoData = async (id) => {
        try {
            const response = await APIserver.get(`/api/facturarPedidos/pedidos/${id}`);
            if (response.status === 200) {
                const pedido = response.data;
                setIdCliente(pedido.idCliente);
                setClienteIDs(pedido.clienteID);
                setNomCliente(pedido.nomCliente);
                setTipoFacturaState(pedido.tipo);
                setSelectedAsesor({ value: pedido.idSucursal, label: pedido.nomSucursal });
                setAsesor(pedido.idSucursal);
            }
        } catch (error) {
            console.error('Error al cargar el pedido:', error);
        }
    };

    const optionsPedido = [
        { value: 'distribucion', label: 'Distribución' },
        { value: 'unidad', label: 'Unidad' }
    ];

    const optionsPago = [
        { value: 'efectivo', label: 'Efectivo' },
        { value: 'banco', label: 'Banco' },
        { value: 'contraentrega', label: 'Contraentrega' }

    ];
    const optionsTranspotadora = [
        { value: 'interrapidisimo', label: 'Interrapidisimo' },
        { value: 'envia', label: 'Envia' },
        { value: 'domicilio', label: 'Domicilio' },
        { value: 'servientrega', label: 'Servientrega' },
        { value: 'otros', label: 'Otros' }
    ];

    const ordenarOpciones = (lista, idPref) => {
        if (!lista || lista.length === 0) return [];
        if (!idPref) return [...lista];

        const preferidos = [];
        const otros = [];

        lista.forEach(item => {
            if (String(item.value) === String(idPref)) {
                preferidos.push(item);
            } else {
                otros.push(item);
            }
        });

        return [...preferidos, ...otros];
    };

    const handleTogglePreferredFormaPago = (val) => {
        let nuevo = '';
        if (String(preferredFormaPago) === String(val)) {
            nuevo = '';
            try {
                localStorage.removeItem('forma_pago_preferida_fac');
            } catch (e) {}
        } else {
            nuevo = String(val);
            try {
                localStorage.setItem('forma_pago_preferida_fac', String(val));
            } catch (e) {}
            setformaPagoState(val);
            setformaPago(val);
        }
        setPreferredFormaPago(nuevo);
    };

    const handleTogglePreferredTransportadora = (val) => {
        let nuevo = '';
        if (String(preferredTransportadora) === String(val)) {
            nuevo = '';
            try {
                localStorage.removeItem('transportadora_preferida_fac');
            } catch (e) {}
        } else {
            nuevo = String(val);
            try {
                localStorage.setItem('transportadora_preferida_fac', String(val));
            } catch (e) {}
            settransportadoraState(val);
            settransportadora(val);
        }
        setPreferredTransportadora(nuevo);
    };

    const CustomOptionFormaPago = (props) => {
        const { data, isSelected, isFocused, innerRef, innerProps } = props;
        const isChecked = String(data.value) === String(preferredFormaPago);

        const handleCheckboxClick = (e) => {
            e.stopPropagation();
            e.preventDefault();
            handleTogglePreferredFormaPago(data.value);
        };

        return (
            <div
                ref={innerRef}
                {...innerProps}
                className="d-flex justify-content-between align-items-center px-3 py-2"
                style={{
                    backgroundColor: isSelected
                        ? '#2c4cc4'
                        : isFocused
                        ? '#eef2ff'
                        : '#ffffff',
                    color: isSelected ? '#ffffff' : '#212529',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f1f3f5'
                }}
            >
                <span className="flex-grow-1 text-truncate pe-2">{data.label}</span>
                <div
                    onClick={handleCheckboxClick}
                    title={isChecked ? 'Quitar de preferido' : 'Chulear para que salga de primero y predefinido'}
                    className="d-flex align-items-center ps-2"
                    style={{ cursor: 'pointer' }}
                >
                    <input
                        type="checkbox"
                        className="form-check-input m-0"
                        checked={isChecked}
                        onChange={handleCheckboxClick}
                        style={{
                            cursor: 'pointer',
                            width: '18px',
                            height: '18px',
                            accentColor: '#2c4cc4'
                        }}
                    />
                </div>
            </div>
        );
    };

    const CustomOptionTransportadora = (props) => {
        const { data, isSelected, isFocused, innerRef, innerProps } = props;
        const isChecked = String(data.value) === String(preferredTransportadora);

        const handleCheckboxClick = (e) => {
            e.stopPropagation();
            e.preventDefault();
            handleTogglePreferredTransportadora(data.value);
        };

        return (
            <div
                ref={innerRef}
                {...innerProps}
                className="d-flex justify-content-between align-items-center px-3 py-2"
                style={{
                    backgroundColor: isSelected
                        ? '#2c4cc4'
                        : isFocused
                        ? '#eef2ff'
                        : '#ffffff',
                    color: isSelected ? '#ffffff' : '#212529',
                    cursor: 'pointer',
                    borderBottom: '1px solid #f1f3f5'
                }}
            >
                <span className="flex-grow-1 text-truncate pe-2">{data.label}</span>
                <div
                    onClick={handleCheckboxClick}
                    title={isChecked ? 'Quitar de preferido' : 'Chulear para que salga de primero y predefinido'}
                    className="d-flex align-items-center ps-2"
                    style={{ cursor: 'pointer' }}
                >
                    <input
                        type="checkbox"
                        className="form-check-input m-0"
                        checked={isChecked}
                        onChange={handleCheckboxClick}
                        style={{
                            cursor: 'pointer',
                            width: '18px',
                            height: '18px',
                            accentColor: '#2c4cc4'
                        }}
                    />
                </div>
            </div>
        );
    };
    const searchClientes = async (nombre) => {
        try {
            const response = await APIserver.get(`/api/nombre/buscar?nombre=${nombre}`);
            setSearchResults(response.data);
        } catch (error) {
            console.error('Error al buscar clientes:', error);
        }
    };

    const handleIdClienteChange = async (e) => {
        const id = e.target.value;
        setIdCliente(id);
        setClienteID(id);

        if (id.length === 10) {
            try {
                const response = await APIserver.get(`/api/buscarClientes/${id}`);
                if (response.status === 200) {
                    setNomCliente(response.data.nomCliente || '');
                }
            } catch (error) {
                if (error.response && error.response.status === 404) {
                    setNomCliente('Cliente no encontrado');
                } else {
                    console.error('Error al buscar el cliente:', error);
                }
            }
        } else {
            setNomCliente('');
        }
    };

    const handleNomClienteChange = (selectedOption) => {
        if (selectedOption) {
            setIdCliente(selectedOption.value);
            setNomCliente(selectedOption.label);
            setShowModal(false);
            setClienteID(selectedOption.value);
        }
    };

    const handleAsesorChange = (selectedOption) => {
        setSelectedAsesor(selectedOption);
        setAsesor(selectedOption ? selectedOption.value : '');
    };

    const handleSearchClick = () => {
        searchClientes(nomCliente);
        setShowModal(true);
    };

    const handleSelectCliente = (cliente) => {
        setIdCliente(cliente.idCliente);
        setClienteIDs(cliente.clienteID);
        setNomCliente(cliente.nomCliente);
        setShowModal(false);
        setClienteID(cliente.idCliente);
    };

    const handleTipoFacturaChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        setTipoFacturaState(selectedValue);
        setTipoFactura(selectedValue); // Actualiza tipoFactura en el componente principal
    };

    const handleformaPagoChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        setformaPagoState(selectedValue);
        setformaPago(selectedValue);
    };
    const handletransportadoraChange = (selectedOption) => {
        const selectedValue = selectedOption ? selectedOption.value : '';
        settransportadoraState(selectedValue);
        settransportadora(selectedValue);
    };
    const handleDondePagoChange = (e) => {
        const value = e.target.value;
        setDondePagoState(value);
        setdondePago(value); // Actualiza el estado en el componente padre
    };
    const handleNumGuiaChange = (e) => {
        const value = e.target.value;
        setNumGuiaState(value);
        setnumGuia(value); // Actualiza el estado en el componente padre
    };
    return (
        <>
            <Form>
                <Row>
                    <Col>
                        <Form.Group className='mt-0' controlId='idCliente'>
                            <Form.Label className='w-100'>Identificación
                                <Form.Control
                                    type='number'
                                    name='idCliente'
                                    placeholder='Identificación del cliente'
                                    className='mt-2'
                                    value={clienteID}
                                    onChange={handleIdClienteChange}
                                    required
                                />
                            </Form.Label>
                        </Form.Group>
                        <Form.Group className='mt-2' controlId='venceFactura'>
                            <Form.Label className='w-100'>Vence
                                <Form.Control
                                    type='date'
                                    name='venceFactura'
                                    className='mt-2'
                                    value={venceDate}
                                    required
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        setVenceDateState(selectedDate);
                                        setVenceDate(selectedDate);
                                    }}
                                />
                            </Form.Label>
                        </Form.Group>
                        <Form.Group className='mt-2' controlId='formaPago'>
                            <Form.Label className='w-100'>Forma de Pago
                                <Select
                                    placeholder='Forma de Pago'
                                    name='formaPago'
                                    className='mt-2'
                                    options={ordenarOpciones(optionsPago, preferredFormaPago)}
                                    value={optionsPago.find(option => option.value === formaPago) || null}
                                    onChange={handleformaPagoChange}
                                    components={{ Option: CustomOptionFormaPago }}
                                    required
                                />
                            </Form.Label>
                        </Form.Group>
                    </Col>
                    <Col>
                        <Form.Group className="mt-0" controlId="nomCliente">
                            <Form.Label>Cliente</Form.Label>
                            <InputGroup className="mb-3">
                                <Form.Control
                                    type='text'
                                    placeholder='Nombre del cliente'
                                    value={nomCliente}
                                    onChange={(e) => setNomCliente(e.target.value)}
                                />
                                <Button variant='outline-dark' title='Buscar cliente' onClick={handleSearchClick}>
                                    <Search />
                                </Button>
                            </InputGroup>
                        </Form.Group>
                        <Form.Group className='mt-2' controlId='transportGroup'>
                            <Form.Label className='w-100'>Transportadora
                                <Select
                                    placeholder='transportadora'
                                    name='transport'
                                    className='mt-2'
                                    options={ordenarOpciones(optionsTranspotadora, preferredTransportadora)}
                                    value={optionsTranspotadora.find(option => option.value === transport) || null}
                                    onChange={handletransportadoraChange}
                                    components={{ Option: CustomOptionTransportadora }}
                                    required
                                />
                            </Form.Label>
                        </Form.Group>
                        <Form.Label className='w-100 mt-2'>Numero de Guia
                            <Form.Control
                                type='number'
                                name='Numero de Guia'
                                placeholder='numGuia'
                                className='mt-2'
                                value={numGuia}
                                onChange={handleNumGuiaChange}
                                required
                            />
                        </Form.Label>
                    </Col>
                    <Col>
                        <Form.Group className='mt-0' controlId='creacionFactura'>
                            <Form.Label className='w-100'>Elaboración
                                <Form.Control
                                    type='date'
                                    name='creacionFactura'
                                    className='mt-2'
                                    value={creacionDate}
                                    required
                                    onChange={(e) => {
                                        const selectedDate = e.target.value;
                                        setCreacionDateState(selectedDate);
                                        setCreacionDate(selectedDate);
                                    }}
                                />
                            </Form.Label>
                        </Form.Group>


                        <Form.Group className='mt-2' controlId='nomSucursal'>
                            <Form.Label className='w-100'>¿En donde pago?
                                <Form.Control
                                    type='text'
                                    name='dondePago'
                                    placeholder='¿En donde pago?'
                                    className='mt-2'
                                    value={dondePago}
                                    onChange={handleDondePagoChange}
                                    required
                                />
                            </Form.Label>
                        </Form.Group>
                        <Form.Group className='mt-2' controlId='tipoFactura'>
                            <Form.Label className='w-100'>Tipo
                                <Select
                                    placeholder='Tipo de Factura'
                                    name='tipoFactura'
                                    className='mt-2'
                                    options={optionsPedido}
                                    value={optionsPedido.find(option => option.value === tipoFactura)}
                                    onChange={handleTipoFacturaChange}
                                    isDisabled
                                    required
                                />
                            </Form.Label>
                        </Form.Group>
                    </Col>
                </Row>
            </Form>

            {/* Modal de búsqueda de clientes */}
            <Modal show={showModal} onHide={() => setShowModal(false)} size="lg">
                <Modal.Header closeButton>
                    <Modal.Title>Seleccionar Cliente</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <InputGroup className="mb-3">
                        <Form.Control
                            type='text'
                            placeholder='Buscar cliente por nombre, cedula o numero'
                            value={nomCliente}
                            onChange={(e) => {
                                setNomCliente(e.target.value);
                                searchClientes(e.target.value);
                            }}
                        />
                    </InputGroup>
                    <Table responsive className='shadow-none text-center mt-3'>
                        <thead className='bg-primary-subtle'>
                            <tr>
                                <th>NIT</th>
                                <th>Nombre</th>
                                <th>Numero</th>

                                <th>Acción</th>
                            </tr>
                        </thead>
                        <tbody>
                            {searchResults.length === 0 ? (
                                <tr>
                                    <td colSpan="3">Cliente no encontrado</td>
                                </tr>
                            ) : (
                                searchResults.map(cliente => (
                                    <tr key={cliente.idCliente}>
                                        <td>{cliente.clienteID}</td>
                                        <td>{cliente.nomCliente}</td>
                                        <td>{cliente.numCliente}</td>

                                        <td>
                                            <Button variant='outline-success' size='sm' onClick={() => handleSelectCliente(cliente)}>
                                                Seleccionar
                                            </Button>
                                        </td>
                                    </tr>
                                ))
                            )}
                        </tbody>
                    </Table>
                </Modal.Body>
                <Modal.Footer>
                    <Button variant="secondary" onClick={() => setShowModal(false)}>
                        Cerrar
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
    );
}

export default ClienteFactura;
